module.exports = require('./helpers/bundle-url').getBundleURL('d2duB') + "logo.c51670a8.svg";